export const environment = {
  production: false,
  appUrl: 'http://localhost:4202',
  useLocalWasmFiles: false,
};

